import React from "react";
import { CustomTable } from "../../../Shared";

export function ListPayments(props) {
  const {
    payments = [],
    loading = false,
    error = null,
    tableConfig,
    onReload,
  } = props;

  if (error) {
    return (
      <p style={{ color: "red", textAlign: "center", margin: "1rem 0" }}>
        {error}
      </p>
    );
  }
  
  return (
    <div className="student-my-payments__list">
      <CustomTable
        tableConfig={tableConfig}
        data={payments}
        loading={loading}
        onReload={onReload}
      />
    </div>
  );
}
